import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import React, { useEffect } from "react";
import { useState } from "react";
import storage from "../../../Services/Storage";
import Loader from "../../../Components/Loader";
import Axios from "../../../api/Axios";
import { toast } from "react-toastify";
import WarnMessege from "./WarnMessege";
// import { Checkbox } from "primereact/checkbox";

const UserAddPaymentUPI = () => {
    const [checked, setChecked] = useState(false);
    // const [checkeden, setCheckeden] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showalert, setShowalert] = useState(false);
    const [mobNo, setMobNo] = useState("");
    const [upiId, setUpiId] = useState("");
    const [upidataAll, setUpidataAll] = useState([]);
    const [getUPIdata, setGetUPIdata] = useState([]);

    const auth = storage.getLocal("user");
    const onPageLoad = async () => {
        try {
            setLoading(true);
            const paymnturl = "ParameterSettings/GetEInvoiceItem?";
            // /api/ParameterSettings/GetUPITrackRecords
            // ParameterSettings/GetEInvoiceItem?

            const upiData = `${paymnturl}compid=${auth.CompId}`;
            let dataresponse = await Axios.get(upiData);
            setMobNo(dataresponse?.data?.Data[0]?.MOBILE ?? "");
            setUpiId(dataresponse?.data?.Data[0]?.PAYMENT_UPI_ID ?? "");
            if (dataresponse?.data?.Data[0]?.B2C_QR == "Y") {
                setChecked(true);
            }
            // if (dataresponse?.data?.Data[0]?.SELF_DECLARATION == "Y") {
            //     setCheckeden(true);
            // }
            setGetUPIdata(dataresponse?.data?.Data[0]);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    const onPageLoaddatat = async () => {
        try {
            setLoading(true);
            const paymnturl = "ParameterSettings/GetUPITrackRecords?";
            const upiData = `${paymnturl}compid=${auth.CompId}`;
            let dataresponse = await Axios.get(upiData);
            setUpidataAll(dataresponse?.data?.Data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        onPageLoad();
        onPageLoaddatat();
    }, []);

    const saveUPIdata = () => {
        const upiRegex = /^[a-zA-Z0-9._-]{2,256}@[a-zA-Z]{2,64}$/;
        // console.log(upiId);
        // debugger;
        if (checked) {
            if (upiId.toString().trim().length < 2) {
                toast.warn("UPI ID cannot be blank", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                return;
            }
            if (!upiRegex.test(upiId)) {
                toast.warn("Invalid UPI ID", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                return;
            }
            else {
                setShowalert(true);
            }
        } else {
            setShowalert(true);
        }
    };
    const proceedFurther = async () => {
        try {
            // console.log(getUPIdata, "getUPIdata");
            // return;
            setShowalert(false);
            let payload = {
                irpUserId: getUPIdata.IRP_USER_ID,
                irpUserPassword: getUPIdata.IRP_PASSWORD,
                gstin: auth.EInvGSTNO,
                chkEInvoicing: getUPIdata.E_INVOICING == "Y" ? true : false,
                chkB2CPaymentQR: checked,
                isPQR: true,
                upiId: upiId.trim(),
                compID: auth.CompId,
                strLoginUserId: auth.UserId,
            };

            // console.log(payload);
            // return;
            setLoading(true);
            let postURL = "ParameterSettings/SaveInvoice";
            let dataresponse = await Axios.post(postURL, JSON.stringify(payload), {
                headers: { "Content-Type": "application/json" },
            });
            toast.success(`${dataresponse.data.Message}`, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            onPageLoad();
            onPageLoaddatat();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    // const clickEnble = async () => {
    //     try {
    //         let url = "ParameterSettings/UpdateSelfDeclaration?";
    //         let res = await Axios.get(
    //             `${url}strSelfDeclaration=Y&compID=${auth.CompId}&UserId=${auth.UserId}`
    //         );
    //         toast.success("Records save successfully", {
    //             position: toast.POSITION.TOP_CENTER,
    //             pauseOnFocusLoss: false,
    //             closeButton: false,
    //             autoClose: 2000,
    //         });
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    const alertmessege = `ALERT: The UPI details entered by you will be used to print Payment QR codes
     on the invoices generated in InnoRise. Continue only if the UPI id is a valid one 
     and is linked with a bank account in which you wish to receive the money from your 
     Customers. Please note that invalid or wrong UPI ids will lead to unsuccessful payments 
     or money being credited to a wrong bank account. If you have updated the UPI id to a new one,
      please note that the invoices already printed with the previous UPI details when scanned 
      will be credited to the bank account associated with the previous UPI id. To get payments
       from customers for previous invoices on the current UPI id, please take a reprint of
        those invoices and share with your customers. IF YOU WISH TO CONTINUE PLEASE CLICK 
        PROCEED OR ELSE TO DISCARD THE CHANGES CLICK CANCEL.`;

    const stateProps = {
        setShowalert,
        showalert,
        proceedFurther,
        alertmessege,
    };

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Add Payment UPI</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12"></div>
                </div>
                <section>
                    <div className="row">
                        <div className="col-lg-5 col-md-12 col-sm-12">
                            <div className="sales-box">
                                <form>
                                    <div className="d-block mb-2">
                                        <label className="form-label">
                      Payment QR <span className="mandatory">*</span>
                                        </label>
                                        <InputSwitch
                                            className="switch-pos ms-2"
                                            checked={checked}
                                            onChange={(e) => setChecked(e.value)}
                                        />
                                    </div>
                                    <div className="d-block mb-3">
                                        <label className="form-label">
                      Payment UPI ID <span className="mandatory">*</span>
                                        </label>
                                        <InputText
                                            className="form-control"
                                            disabled={!checked}
                                            value={upiId}
                                            onChange={(e) => setUpiId(e.target.value)}
                                        />
                                    </div>
                                    <div className="d-block mb-3">
                                        <label className="form-label">
                      SMS Alert Sent To <span className="mandatory">*</span>
                                        </label>
                                        <InputText
                                            className="form-control"
                                            required
                                            disabled
                                            value={mobNo}
                                            onChange={(e) => setMobNo(e.value)}
                                        />
                                    </div>
                                    {loading ? (
                                        <>
                                            <Loader />
                                        </>
                                    ) : null}
                                    <div className="d-block mt-4">
                                        <div className="text-end">
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={saveUPIdata}
                                                // disabled={!checked}
                                            >
                        Save
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="col-lg-7 col-md-12 col-sm-12">
                            <div className="DataTable">
                                <DataTable
                                    value={upidataAll}
                                    showGridlines
                                    stripedRows
                                    scrollHeight="80vh"
                                    scrollable
                                >
                                    <Column field="PAYMENT_UPI_ID" header="UPI Details"></Column>
                                    <Column field="MODIFIED_BY" header="Defined By"></Column>
                                    <Column field="MODIFIED_ON" header="Defined On"></Column>
                                    <Column field="MOBILE" header="SMS Alert Sent To"></Column>
                                    <Column field="STATUS" header="	Status"></Column>
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <section className="sales-box">
                          <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-lg-1 col-md-1 col-sm-1 width3">
                              <div className="">
                                <label className="chekbox-container d-inline">
                                  <Checkbox
                                    onChange={(e) => setCheckeden(e.checked)}
                                    checked={checkeden}
                                    disabled={checkeden}
                                  ></Checkbox>
                                </label>
                              </div>
                            </div>
                            <div className="col-lg-11 col-md-11 col-sm-11 ms-0 me-0 ps-0">
                              <label className="form-label">
                                My AATO will be greater than or equal to INR 100 crores. Hence,
                                I opt to complete my E-Invoicing within 30 days of invoice
                                generation to avoid applicable penalties. My E-invoicing will be
                                disabled after 30 days of invoice generation.
                              </label>
                            </div>
                          </div>
                          <div className="d-block mt-3">
                            <div className="text-start ms-5">
                              <button
                                type="button"
                                title="Click to Enable"
                                className="btn btn-primary ms-2"
                                // disabled={!checked}
                                onClick={clickEnble}
                              >
                                Click to Enable
                              </button>
                            </div>
                          </div>
                        </section> */}
                {/* <section className="sales-box green-bg">
                          <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                              <h6>What needs to be done</h6>
                              <ul className="additem">
                                <li>
                                  The E-invoicing should be done within 30 days from the Invoice
                                  Date.
                                </li>
                                <li>
                                  You need to be sure that your E-invoicing is not lacking IRN
                                  and signed QR code.{" "}
                                </li>
                              </ul>
                              <h6>According to GST Network&apos;s advisory</h6>
                              <ul className="additem">
                                <li>
                                  On incorrect invoicing - Rs. 25,000 per invoice (For lack of
                                  IRN and signed QR code)
                                </li>
                                <li>
                                  On non-generation of E-Invoice - 100% of the tax due or
                                  Rs.10,000 whichever is higher, for every invoice.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </section> */}
            </div>
            <WarnMessege stateProps={stateProps} />
        </>
    );
};

export default UserAddPaymentUPI;
